/*
    Copy text from any appropriate field to the clipboard
*/

'use strict';

if (document.getElementById('copy-link')) {
    // click events
    document.getElementById('copy-link').addEventListener('click', copy, true);

    // event handler
    function copy(e) {
        // find target element
        var t = e.target,
            dummyInput = document.createElement('input'),
            text = window.location.href;

        try {
            // copy text
            document.body.appendChild(dummyInput);
            dummyInput.value = text;
            dummyInput.select();
            document.execCommand('copy');
            document.body.removeChild(dummyInput);

            // copied animation
            t.classList.add('copied');
            setTimeout(function() {
                t.classList.remove('copied');
            }, 1500);
        } catch (err) {
            alert('Please press Ctrl/Cmd+C to copy');
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/copy-text.js